export default function CanViewAdmin(me) {
  if (!me) return false
  const {roles, roleInWebsite} = me
  if (roles && roles.length) return true

  if (!roleInWebsite) return false

  return ['admin', 'marketing', 'content', 'storeAdmin'].includes(roleInWebsite.role)
}
